export default { sha: '8b52cd7bed64c17bbbd794f42dd0356d49e4f1ea', buildNumber: 'undefined' }
